/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindAgecComplianceQueryResponse,
  FindAgecComplianceQueryParams,
} from "../types/FindAgecCompliance.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findAgecComplianceQueryKey = (
  params: FindAgecComplianceQueryParams
) =>
  [
    { url: "/v1/product/find-agec-compliance" },
    ...(params ? [params] : []),
  ] as const

export type FindAgecComplianceQueryKey = ReturnType<
  typeof findAgecComplianceQueryKey
>

/**
 * @summary Find agec compliance
 * {@link /v1/product/find-agec-compliance}
 */
export async function findAgecCompliance(
  params: FindAgecComplianceQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindAgecComplianceQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-agec-compliance`,
    params,
    ...requestConfig,
  })
  return res
}

export function findAgecComplianceQueryOptions(
  params: FindAgecComplianceQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findAgecComplianceQueryKey(params)
  return queryOptions<
    ResponseConfig<FindAgecComplianceQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindAgecComplianceQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findAgecCompliance(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find agec compliance
 * {@link /v1/product/find-agec-compliance}
 */
export function useFindAgecCompliance<
  TData = ResponseConfig<FindAgecComplianceQueryResponse>,
  TQueryData = ResponseConfig<FindAgecComplianceQueryResponse>,
  TQueryKey extends QueryKey = FindAgecComplianceQueryKey,
>(
  params: FindAgecComplianceQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindAgecComplianceQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findAgecComplianceQueryKey(params)

  const query = useQuery(
    {
      ...findAgecComplianceQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
